import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-sm border border-carbon-100 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-carbon-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-carbon-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-carbon-800 dark:bg-carbon-950 dark:ring-offset-carbon-950 dark:placeholder:text-carbon-400 dark:focus-visible:ring-carbon-300",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
